<template>
	<svg @click="close()" :width="modal ? 15 : 22" :height="modal ? 15 : 22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M1 1L20.5 20.5" :stroke="modal ? 'black' : 'white'" :stroke-width="modal ? 3 : 2" />
		<path d="M20.5 1L1 20.5" :stroke="modal ? 'black' : 'white'" :stroke-width="modal ? 3 : 2" />
	</svg>
</template>

<script>
	export default {
		name: 'CloseSVG',
		props: {
			modal: Boolean
		},
		methods: {
			close() {
				this.$emit('click');
			}
		}
	};
</script>

<style scoped></style>
